var FuseThemeOptionsModule = /** @class */ (function () {
    function FuseThemeOptionsModule() {
    }
    return FuseThemeOptionsModule;
}());
export { FuseThemeOptionsModule };
